import {
  CardActions,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import StyledButton from "../../Page/Landing/components/StyledButton";
import actions from "../../redux/actions";

function SuspendModal(props) {
  const {
    isFetching,
    resetModal,
    isOpen,
    suspendSession,
    modalData,
    setModalData,
  } = props;

  const onClose = () => {
    resetModal();
  };
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <Typography variant="h6">تعلیق کلاس توسط</Typography>
        <br />
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={modalData.suspended_by}
            onChange={(e) => {
              setModalData({ suspended_by: Number(e.target.value) });
            }}
          >
            <FormControlLabel value={2} control={<Radio />} label="استاد" />
            <FormControlLabel value={3} control={<Radio />} label="دانشجو" />
          </RadioGroup>
        </FormControl>
        <br />
        <br />
      </DialogContent>
      <CardActions>
        <StyledButton variant="outlined" onClick={onClose}>
          لغو
        </StyledButton>
        <div style={{ flexGrow: 1 }} />
        <StyledButton
          onClick={(_) => suspendSession()}
          variant="contained"
          color="primary"
        >
          {isFetching ? (
            <CircularProgress size="1.2rem" color="#ffffff" />
          ) : (
            "ثبت"
          )}
        </StyledButton>
      </CardActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  isOpen: state.dashboard.suspendModal.isOpen,
  modalData: state.dashboard.suspendModal.data,
  isFetching: state.dashboard.suspend.fetching,
});
const mapDispatchToProps = (dispatch) => ({
  suspendSession: () => dispatch(actions.dashboard.suspend.suspendSession()),
  setModalData: (data) =>
    dispatch(actions.dashboard.suspendModal.setData(data)),
  resetModal: () => dispatch(actions.dashboard.suspendModal.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuspendModal);
